import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import SectionTitle from "../../components/Common/SectionTitle";
import ConsultationForm from "../../components/Consultation/ConsultationForm";
import OffWrap from "../../components/Layout/Header/OffWrap";
import Footer from "../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../components/Common/ScrollTop";
import Newsletter from "../../components/Common/Newsletter";
import Header from "../../components/Layout/Header/Header";

import bannerbg from "../../assets/img/breadcrumbs/inner13.jpg";
import contactHereImg from "../../assets/img/services/121.png";
import Logo from "../../assets/img/logo/dark-logo.png";
import footerLogo from "../../assets/img/logo/lite-logo.png";
import favIcon from "../../assets/img/fav.png";

const ConsultationMain = () => {
  return (
    <React.Fragment>
      <Helmet>
        <link rel="icon" href={favIcon} />
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="pages"
        secondParentMenu="others"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        CanvasLogo={Logo}
        mobileNormalLogo={Logo}
        CanvasClass="right_menu_togle hidden-md"
        headerClass="full-width-header header-style1 home8-style4"
        TopBar="enable"
        TopBarClass="topbar-area home8-topbar"
        emailAddress="hello@syroltech.com"
        Location="Abuja, Nigeria"
      />
      {/* SiteBreadcrumb */}
      <SiteBreadcrumb
        pageTitle="Request for a Free Consultation"
        pageName="Request for a Free Consultation"
        breadcrumbsImg={bannerbg}
      />
      {/* SiteBreadcrumb */}

      {/* Consultation Section Start */}
      <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
        <div className="container pb-66 md-pb-46">
          <div className="row y-middle">
            <div className="col-lg-6 md-mb-30">
              <div className="contact-widget">
                <SectionTitle
                  sectionClass="sec-title3 mb-36"
                  titleClass="title black-color mb-14"
                  title="Request for a Free Consultation"
                  descClass="new-desc"
                  description="Schedule a consultation with our experts. Fill out the form and we will get back to you to discuss your project requirements."
                />
                {/* Consultation Form */}
                <ConsultationForm submitBtnClass="btn-send" btnText="Request Demo" />
                {/* Consultation Form */}
              </div>
            </div>
            <div className="col-lg-6 pl-60 md-pl-14 d-flex align-items-center justify-content-center">
              <div className="consultation-visual text-center">
                <img src={contactHereImg} alt="Request Free Consultation" style={{maxWidth: '100%', height: 'auto'}} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Consultation Section End */}

      <Newsletter
        sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
        titleClass="title mb-0 white-color"
      />
      {/* Newsletter Section End */}

      {/* Footer */}
      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />
      {/* Footer */}

      {/* SearchModal */}
      <SearchModal />
      {/* SearchModal */}

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
    </React.Fragment>
  );
};

export default ConsultationMain; 